module.exports = __webpack_public_path__ + "6d03917d75ee0a50ca3aeabd805d5e4b.png";